export class BCASearch {
  builderId: string[];
  projectName: any;
  projectAddress: any;
  bcaStatus: any;
  subsidaryId: any;
  subsidarycompanyName: any;
  startDate: Date;
  endDate: Date;
  reqId?: any;
  bcaStatusValue: any;
}
